"use strict";

(function() {
  var shellPackages = [
    {
      name: "suiteux.shell.responsive",
      resourceLoader: function() {
        require("./js/suiteux.shell.responsive");
      }
    }
  ];

  require("./js/suiteux.shell.bootstrapper");

  shellPackages.forEach(function(shellPackage) {
    O365Shell.SetLoadPackageHandler(shellPackage.name, function(
      successHandler,
      failureHandler
    ) {
      try {
        shellPackage.resourceLoader();
        if (successHandler) {
          successHandler();
        }
      } catch (exception) {
        if (failureHandler) {
          failureHandler({
            ResourceName: shellPackage.name,
            Details: "SetLoadPackageHandler failure: " + exception.message
          });
        }
      }
    });
  });
})();

exports.O365Shell = window.O365Shell;
